const searchForProvState = (element, term) => {
    const states = { 'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas', 'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware', 'DC': 'District of Columbia', 'FL': 'Florida', 'GA': 'Georgia', 'HI': 'Hawaii', 'ID': 'Idaho', 'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas', 'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland', 'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi', 'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada', 'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York', 'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio', 'OK': 'Oklahoma', 'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina', 'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah', 'VT': 'Vermont', 'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia', 'WI': 'Wisconsin', 'WY': 'Wyoming' }

    const provinces = { "BC": "British Columbia", "ON": "Ontario", "NL": "Newfoundland and Labrador", "NS": "Nova Scotia", "PE": "Prince Edward Island", "NB": "New Brunswick", "QC": "Quebec", "MB": "Manitoba", "SK": "Saskatchewan", "AB": "Alberta", "NT": "Northwest Territories", "NU": "Nunavut", "YT": "Yukon" };
    let result = -1;

    for (const [key, value] of Object.entries(states)) {
        if (value.toLowerCase().indexOf(term) > -1) {
            if (element.indexOf(key.toLowerCase()) > -1) {
                return element.indexOf(key.toLowerCase());
            }
        }
    }
    for (const [key, value] of Object.entries(provinces)) {
        if (value.toLowerCase().indexOf(term) > -1) {
            if (element.indexOf(key.toLowerCase()) > -1) {
                return element.indexOf(key.toLowerCase());
            }
        }
    }



    return result;
}
const searchDateRangeDesc = (element, term) => {
    //console.log("element: "+element);
    //console.log("term: "+term);
    let foundTerm = 1;
    //does the term and element contain an un-empty string
    if (element.length > 0 && term.length > 0) {
        //split the search term on spaces
        const terms = term.split(" ");
        //console.log(terms);
        let i = 0;
        //iterate through the list of search terms if any item in terms doesn't
        //exist in the date range description then return -1 for not found.
        //If someone searches for April 23 that string must be found in a date range description such as April 23 or April 22, 23, 24 or Previous dates: April 21,22,23,24.
        while (foundTerm > -1 && i < terms.length) {
            const curr = terms[i];
            //console.log('curr: '+curr);
            foundTerm = element.indexOf(curr.toLowerCase());

            i++;
        }

        return foundTerm;

    }

    return foundTerm;
}
const wtsearch = { searchDateRangeDesc, searchForProvState }
export default wtsearch;